'use strict'

import angular from 'angular'
import moment from 'moment'

angular.module('activityLog.controllers', [])
    .controller('ActivityLogController', ActivityLogController)
    .filter('humanizeTableName', function () {
        return function (input) {
            if (input == null) return input
            return String(input).split('_').join(' ')
        }
    })

/**
 * @ngInject
 */
function ActivityLogController($scope, $stateParams, $rootScope, $ioAlert, CurrentUser, ActivityLogService, ErrorsHandler) {
    $rootScope.loadertitle = ''
    $rootScope.loadingInProgress = true
    $scope.loading = true
    $scope.afterCreatedAtDate = moment().subtract(1, 'day').toDate()


    CurrentUser.get().then(() => {
        loadActivityLogs(() =>  {
            $rootScope.loadingInProgress = false
        })
    })

    function loadActivityLogs(callback) {
        $scope.loading = true
        const afterCreatedAt = $scope.afterCreatedAtDate
            ? moment($scope.afterCreatedAtDate).format('YYYY-MM-DD')
            : undefined
        ActivityLogService.getAllActivityLogsAugmentedAfter(afterCreatedAt).then((activityLogs) => {
            $scope.loading = false
            $scope.activityLogs = presentData(activityLogs)
            $scope.hasActivityLogs = !!$scope.activityLogs && Object.keys($scope.activityLogs).length > 0
            if (callback) {
                callback()
            }
        }, (error) => {
            ErrorsHandler.handle(error)
            $scope.loading = false
            if (callback) {
                callback()
            }
        })
    }

    function presentData(activityLogs) {
        const grouped = {}
        if (!activityLogs || !Array.isArray(activityLogs.activityLogEntries)) {
            return grouped
        }

        activityLogs.activityLogEntries.forEach(entry => {
            const key = entry.table_name
            if (!grouped[key]) grouped[key] = []

            let parsedDelta = entry.delta
            if (typeof parsedDelta === 'string') {
                try {
                    parsedDelta = JSON.parse(parsedDelta)
                } catch (e) {
                    // leave as original string if parsing fails
                }
            }

            grouped[key].push({
                id: entry.id,
                modified_at: moment(entry.created_at).format('YYYY-MM-DD HH:mm:ss'),
                name: entry.entity_name ? entry.entity_name : String(entry.table_name).split('_').join(' '),
                table_row_id: entry.table_row_id,
                user: entry.name,
                action: entry.action,
                delta: parsedDelta
            })
        })

        return grouped

    }

    $scope.reloadActivityLogs = () => {
        loadActivityLogs()
    }

    $scope.reloadActivityLogsSinceYesterday = () => {
        $scope.afterCreatedAtDate = moment().subtract(1, 'day').toDate()
        loadActivityLogs()
    }
}